import apiClient from './Api';
const PREFIX = '/dashboard';

const getDashboardCount = postData => {
  return apiClient({
    url: `${PREFIX}/counts`,
    method: 'POST',
    data: postData
  });
};

const getMonthCount = postData => {
  return apiClient({
    url: `${PREFIX}/monthcount`,
    method: 'POST',
    data: postData
  });
};

const getPublishedChart = postData => {
  return apiClient({
    url: `${PREFIX}/publishedchart`,
    method: 'POST',
    data: postData
  });
};

const getPublishedChartAverages = postData => {
  return apiClient({
    url: `${PREFIX}/publishedchartavg`,
    method: 'POST',
    data: postData
  });
};

const getFlagChart = postData => {
  return apiClient({
    url: `${PREFIX}/flagcount`,
    method: 'POST',
    data: postData
  });
};

const getInvCapturedCounts = postData => {
  return apiClient({
    url: `${PREFIX}/monthlycaptured`,
    method: 'POST',
    data: postData
  });
};

const getInvCapturedDailyCounts = postData => {
  return apiClient({
    url: `${PREFIX}/dailycapturedcounts`,
    method: 'POST',
    data: postData
  });
};

const getAvgTtm = postData => {
  return apiClient({
    url: `${PREFIX}/avgttm`,
    method: 'POST',
    data: postData
  });
};

const getCutouts = postData => {
  return apiClient({
    url: `${PREFIX}/cutouts`,
    method: 'POST',
    data: postData
  });
};

const downloadFlagData = postData => {
  return apiClient({
    url: `${PREFIX}/exportflags`,
    method: 'POST',
    data: postData,
    responseType: 'blob'
  });
};

const downloadCompositionFlagData = postData => {
  return apiClient({
    url: `${PREFIX}/compositionflagcount`,
    method: 'POST',
    data: postData,
    responseType: 'blob'
  });
};
const getInvChartCount = postData => {
  return apiClient({
    url: `${PREFIX}/invchartcount`,
    method: 'POST',
    data: postData
  });
};

/* // NOT IN USE

const getDailyPhotoPublishedCount = postData => {
  return apiClient({
    url: `${PREFIX}/dailyphotocount`,
    method: 'POST',
    data: postData
  });
};
const getDealerMonthCount = postData => {
  return apiClient({
    url: `${PREFIX}/dealermonthcount`,
    method: 'POST',
    data: postData
  });
};

*/

const getServiceIndicators = postData => {
  return apiClient({
    url: `${PREFIX}/servicestats`,
    method: 'POST',
    data: postData
  });
};

const getLeadCounts = postData => {
  return apiClient({
    url: `${PREFIX}/leadcounts`,
    method: 'POST',
    data: postData
  });
};

const getAvgTtmStats = postData => {
  return apiClient({
    url: `${PREFIX}/ttmchart`,
    method: 'POST',
    data: postData
  });
};

const getTurnTrendChartData = postData => {
  return apiClient({
    url: `${PREFIX}/turntrendchart`,
    method: 'POST',
    data: postData
  });
};

const getAvgTimeSpent = postData => {
  return apiClient({
    url: `${PREFIX}/analytics/avgtimespent`,
    method: 'POST',
    data: postData
  });
};

const downloadAvgTtmData = postData => {
  return apiClient({
    url: `${PREFIX}/downloadttmchart`,
    method: 'POST',
    data: postData,
    responseType: 'blob'
  });
};

const downloadAllTtmChartData = postData => {
  return apiClient({
    url: `${PREFIX}/downloadallttmchart`,
    method: 'POST',
    data: postData,
    responseType: 'blob'
  });
};

const getAvgLifeSpan = () => {
  return apiClient({
    url: `${PREFIX}/avglifespan`,
    method: 'GET'
  });
};

const getDealerFlags = postData => {
  return apiClient({
    url: `${PREFIX}/dealerflags`,
    method: 'POST',
    data: postData
  });
};

const editIMSID = postData => {
  return apiClient({
    url: `${PREFIX}/changeimsid`,
    method: 'POST',
    data: postData
  });
};

const DashboardService = {
  getAvgTimeSpent,
  downloadAvgTtmData,
  downloadAllTtmChartData,
  getAvgTtmStats,
  getLeadCounts,
  getServiceIndicators,
  getInvChartCount,
  downloadFlagData,
  getCutouts,
  getAvgTtm,
  getMonthCount,
  getPublishedChart,
  getPublishedChartAverages,
  getFlagChart,
  getDashboardCount,
  getInvCapturedCounts,
  getAvgLifeSpan,
  getInvCapturedDailyCounts,
  editIMSID,
  getDealerFlags,
  downloadCompositionFlagData,
  getTurnTrendChartData
};

export default DashboardService;
